import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { resolveBreadcrumbs } from '../config/breadcrumbRegistry';
import { useBreadcrumbTitles } from '../contexts/BreadcrumbTitleContext';

export function useBreadcrumbs() {
  const location = useLocation();
  const { titles } = useBreadcrumbTitles();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

  return useMemo(
    () => resolveBreadcrumbs(location.pathname, searchParams, titles),
    [location.pathname, searchParams, titles],
  );
}
